const RoutePath = {
    login: '/login',
    home: '/',
    dashboard: '/dashboard',
    query: '/query',
    organisation: '/organisation',
    deviceType: '/deviceType',
    user: '/user',
    userConfig: 'config',
    configTemplate: 'template',
    add: 'add',
    update: ':mode/:id',
    viewData: ':mode/:id/viewData',
    kpi: '/kpi',
}

export default RoutePath;